export default "__VITE_ASSET__Sf3NE2vQ__"